import { FacebookOutlined, InstagramOutlined, TikTokOutlined, WhatsAppOutlined, MailOutlined, PhoneOutlined, EnvironmentOutlined, EyeOutlined } from '@ant-design/icons';
import React from 'react';

const Details = () => {
    return (
        <div id="closer" className='w-full bg-gray-900 text-white'>
            {/* Main Footer Content */}
            <div className='container mx-auto py-16 px-6'>
                {/* Logo and Description */}
                <div className='grid grid-cols-1 md:grid-cols-3 gap-10 mb-12'>
                    {/* Company Info */}
                    <div>
                        <h2 className='text-3xl font-bold mb-6 text-green-400'>Notonē.lv</h2>
                        <p className='text-gray-300 mb-6'>
                            Augstākās kvalitātes logu aplīmēšana Ventspilī. Piedāvājam auto un mājas logu tonēšanu, 
                            kā arī citus profesionālus aplīmēšanas pakalpojumus.
                        </p>
                    </div>

                    {/* Contact Information */}
                    <div>
                        <h3 className='text-xl font-semibold mb-6 border-b border-green-400 pb-2 inline-block'>KONTAKTI</h3>
                        <div className='space-y-4 mt-4'>
                            <div className='flex items-center'>
                                <EyeOutlined className='text-green-400 mr-3 text-xl' />
                                <span>SIA Notone</span>
                            </div>
                            <div className='flex items-center'>
                                <EnvironmentOutlined className='text-green-400 mr-3 text-xl' />
                                <span>Reģ. Nr. 50203700681<br/>PVN Nr. LV50203700681</span>
                            </div>
                            <div className='flex items-center'>
                                <MailOutlined className='text-green-400 mr-3 text-xl' />
                                <a href='mailto:info@notone.lv' className='hover:text-green-400 transition-colors'>info@notone.lv</a>
                            </div>
                            <div className='flex items-center'>
                                <PhoneOutlined className='text-green-400 mr-3 text-xl' />
                                <a href='tel:+37126001205' className='hover:text-green-400 transition-colors'>+371 26001205</a>
                            </div>
                        </div>
                    </div>

                    {/* Social Media */}
                    <div>
                        <h3 className='text-xl font-semibold mb-6 border-b border-green-400 pb-2 inline-block'>PIESEKO MUMS</h3>
                        <div className='flex flex-wrap gap-4 mt-4'>
                            <a href='https://www.facebook.com/profile.php?id=61562800841961' 
                               className='w-12 h-12 bg-gray-800 rounded-full flex items-center justify-center hover:bg-green-400 hover:text-gray-900 transition-all'>
                                <FacebookOutlined className='text-2xl' />
                            </a>
                            <a href='https://www.instagram.com/notone.lv' 
                               className='w-12 h-12 bg-gray-800 rounded-full flex items-center justify-center hover:bg-green-400 hover:text-gray-900 transition-all'>
                                <InstagramOutlined className='text-2xl' />
                            </a>
                            <a href='https://www.tiktok.com/@notone.lv' 
                               className='w-12 h-12 bg-gray-800 rounded-full flex items-center justify-center hover:bg-green-400 hover:text-gray-900 transition-all'>
                                <TikTokOutlined className='text-2xl' />
                            </a>
                            <a href='https://wa.me/37126001205' 
                               className='w-12 h-12 bg-gray-800 rounded-full flex items-center justify-center hover:bg-green-400 hover:text-gray-900 transition-all'>
                                <WhatsAppOutlined className='text-2xl' />
                            </a>
                        </div>
                        <div className='mt-6'>
                            <p className='text-gray-300'>Darba laiks: P-Pk: 9:00 - 20:00, S, Sv: 10:00 - 20:00</p>
                        </div>
                    </div>
                </div>
            </div>
            
            {/* Copyright Section */}
            <div className='border-t border-gray-800'>
                <div className='container mx-auto py-6 px-6 flex flex-col md:flex-row justify-between items-center'>
                    <div className='text-gray-400 mb-4 md:mb-0'>
                        Notone.lv © {new Date().getFullYear()} Visas tiesības aizsargātas
                    </div>
                    <div className='text-sm text-gray-500'>
                        <a href="#" className='hover:text-green-400 transition-colors mr-6'>Privātuma politika</a>
                        <a href="#" className='hover:text-green-400 transition-colors'>Lietošanas noteikumi</a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Details;